module.exports = __webpack_public_path__ + "static/eyfs_parent_guide.075a6db4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/policies/eyfs_parent_guide.pdf
// module id = 329
// module chunks = 177890977751730